declare let __webpack_public_path__; 

const url = new URL((document.currentScript as HTMLScriptElement).src);
const widgetLink = url.href.substring(0, url.href.lastIndexOf('/') + 1);
__webpack_public_path__ = widgetLink.replace('/static/js', '');

export {};